import { SystemFieldNames, SystemFieldGroups, getTreatmentGroupsTitle, getTreatmentGroupsDescription, INDEPENDENT_VARIABLES } from './systemFieldConstants'
import { fieldDetails as plantingDensityControlGroup } from './plantingDensityControlGroup'

import type { QField } from '~/features/questionnaire/types'
import type { SystemFieldDetails } from './systemFieldConstants'

const
  independentVariable = INDEPENDENT_VARIABLES.PLANTING_DENSITY,
  schemaEntry: QField = {
    fieldName: SystemFieldNames.plantingDensityTreatmentGroups,
    fieldType: 'COLLECTION',
    visibleWhen: plantingDensityControlGroup.schemaEntry.visibleWhen,
    format: plantingDensityControlGroup.schemaEntry.format
  },
  fieldDetails: SystemFieldDetails = {
    fieldName: SystemFieldNames.plantingDensityTreatmentGroups,
    variableGroup: SystemFieldGroups.EXP_DESIGN,
    isRequired: true,
    title: getTreatmentGroupsTitle(independentVariable),
    description: getTreatmentGroupsDescription(independentVariable),
    treatmentGroupsFor: independentVariable,
    schemaEntry
  }

export {
  fieldDetails
}
